<template>
  <div>
    <aha-icon-button
      :variant="'tertiary'"
      @click="onLegacyImportButtonClicked"
      @keydown.enter="onLegacyImportButtonClicked"
      @keydown.space="onLegacyImportButtonClicked"
      :disabled="isImportButtonDisabled"
      class="legacy-import-button"
      v-tooltip="$i18nPresenter.t('Import')"
    >
      <aha-spinner v-if="isImportingSlides" />
      <aha-icon
        v-if="!isImportingSlides"
        name="upload-simple"
        width="16"
        height="16"
        viewBox="0 0 32 32"
        maintainColor
        class="legacy-import-button-icon"
      />
    </aha-icon-button>
  </div>
</template>

<script>
export default {
  props: {
    isImportingSlides: {
      type: Boolean,
      default: false,
    },
    isImportButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onLegacyImportButtonClicked() {
      this.$emit('importPpt')
    },
  },
}
</script>

<style lang="scss" scoped>
.legacy-import-button {
  svg.legacy-import-button-icon:not(:hover) {
    &:deep(path) {
      stroke: var(--color-gray-90, #4A4A4A);
    }
  }
  &:hover {
    svg.legacy-import-button-icon {
      &:deep(path) {
        stroke: var(--color-primary, #6A1EBB);
      }
    }
  }
}
</style>
